import http from '@/services/api/http';

export default {
  getFaqs() {
    return http.get('api/about/faqs');
  },
  getSitemap() {
    return http.get('api/About/sitemap');
  },
};
